// extracted by mini-css-extract-plugin
export default {"main":"Input_main__Zu33S","email__lable":"Input_email__lable__4S-wS","email__field":"Input_email__field__eEHA9","error":"Input_error__JTy-5","warning":"Input_warning__aSYTC"};